import React, { Component } from 'react';
import { Table } from 'reactstrap';

class OrderTable extends Component {
    render() {
        const td = { padding: 5, fontSize: '0.9em' }

        const data = this.props.data;
    
        let tableData = [];
        let tableRows = [];
        let completedTrades = [];

        if(data && data.length > 0) {
            for(const key in data) {
                const trade = data[key];
                const price = parseFloat(trade.trade.price)

                tableData.push({
                    price,
                    trade
                });
            }

            for(const key in tableData) {
                const trade = tableData[key].trade
                const percent = 100 * trade.trade.amount / trade.trade.originalAmount;

                let tdAmount = {...td,  
                    background: 'url(https://dummyimage.com/100/0b3125/0b3125)', 
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: percent.toString() + '% 100px',
                    opacity: (trade.trade.amount === 0) ? 0.25 : 1.0 }

                let tdPrice = {...td, opacity: (trade.trade.amount === 0) ? 0.25 : 1.0 }

                const row = <tr key={key}><td style={tdAmount}>{ trade.amountFormatted }</td><td style={tdPrice}><span className="bar"></span>{ trade.priceFormatted }</td></tr>;

                if(trade.trade.amount === 0) {
                    completedTrades.push(row)
                } else {
                    tableRows.push(row);
                }
            }

            tableRows.push.apply(tableRows, completedTrades)
        }

        const emptyTd = { padding: 0, borderTop: 'none', borderBottom: 'none', border: 'none'}

        return (
            <div className="order-table">
                <h4>{ this.props.title }</h4>
                <Table>
                    <thead>
                        <tr>
                            <th style={{ border: 'none' }}>
                                # Amount
                            </th>
                            <th style={{ border: 'none' }}>
                                ($) Price
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        { (tableRows.length > 0) ? tableRows : <tr><td style={emptyTd}><span className='emptyTable'><span className='emptyTable'>No { this.props.title.toLowerCase() } have been placed yet.</span></span></td></tr> }
                    </tbody>
                </Table>
            </div>
        );
    }
}

export default OrderTable;